import classnames from "classnames";
import { Modal } from "../Modal";
import UncheckedIcon from "../../public/icon/unchecked2.svg";
import CheckedIcon from "../../public/icon/checked2.svg";
import EyeIcon from "../../public/icon/icon-eye.svg";
import Button from "../UI/Button";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import { ScrollView } from "../UI/ScrollView";
import { BootstrapInput } from "../UI/BootstrapInput";
import { NoticeTextCn, NoticeTextEn } from "./notice";

const Content = ({ className = "", ...restProps }) => {
  return (
    <div className="relative mb-[32px]">
      <ScrollView
        className={classnames("h-[210px] overflow-auto", className)}
        {...restProps}
      >
        <div className="pr-[8px] pb-[24px] text-[14px] leading-[20px] font-medium text-left">
          <NoticeTextEn />
          <br />
          <NoticeTextCn />
        </div>
      </ScrollView>
      <div className="absolute bottom-[-2px] w-[328px] h-[24px] bg-gradient-to-t from-[#fff] to-[rgba(255, 255, 255, 0.0001)]"></div>
    </div>
  );
};

const Step1 = ({ checked, setChecked, nftauthT, onConfirm }) => {
  const confirmDisabled = !checked;

  return (
    <div>
      <div className="text-[24px] leading-[32px] mb-[16px] font-['DIN_Alternate']">
        {nftauthT("t7")}
      </div>
      <Content />
      <div className="flex justify-between h-[40px]">
        <Button
          variant="contained"
          color="secondary"
          component="span"
          className={classnames(
            "w-full h-full rounded-full transition font-medium",
            confirmDisabled
              ? "bg-[#F1F2F3] text-[#C9CCD0]"
              : "text-white hover:opacity-80"
          )}
          onClick={onConfirm}
          disabled={confirmDisabled}
        >
          <span>{nftauthT("t9")}</span>
        </Button>
      </div>
      <div className="flex justify-center items-center mt-[24px]">
        <button
          onClick={() => {
            setChecked(!checked);
          }}
          className="mt-[4px] btn-unstyled font-medium text-[12px] flex items-center text-[#484C53]"
        >
          {checked ? (
            <CheckedIcon className="w-[16px]" />
          ) : (
            <UncheckedIcon className="w-[16px]" />
          )}
          <span className="ml-[8px]">{nftauthT("t10")}</span>
        </button>
      </div>
    </div>
  );
};

const Step2 = ({ defaultUid, nftauthT, onConfirm }) => {
  const [uid, setUid] = useState(defaultUid ?? "");

  return (
    <div>
      <div className="text-[24px] leading-[32px] font-['DIN_Alternate']">
        {nftauthT("t11")}
      </div>
      <BootstrapInput
        className="w-[336px] h-[48px] px-[16px] rounded-[8px] text-[16px] mt-[32px] mb-[48px]"
        placeholder={nftauthT("t12")}
        value={uid}
        onChange={(event) => {
          setUid(event.target.value);
        }}
      />
      <Button
        variant="contained"
        color="secondary"
        component="span"
        className={classnames(
          "w-full h-full rounded-full transition font-medium",
          "text-white hover:opacity-80"
        )}
        onClick={() => {
          onConfirm(uid);
        }}
      >
        <span>{nftauthT("t13")}</span>
      </Button>
    </div>
  );
};

export const ConfirmModal = ({
  defaultUid,
  className = "",
  onUidConfirm,
  onCancel,
}) => {
  const [checked, setChecked] = useState(false);
  const { t: nftauthT } = useTranslation("nftauth");
  const [step, setStep] = useState(1);

  const confirm = () => {
    setStep(2);
  };

  return (
    <Modal
      className={classnames(
        "w-[416px] rounded-[48px] overflow-hidden p-[40px] pt-[48px] text-center",
        className
      )}
      onClose={onCancel}
    >
      <div className="mb-[32px]">
        <EyeIcon />
      </div>
      {step === 1 && (
        <Step1
          nftauthT={nftauthT}
          checked={checked}
          setChecked={setChecked}
          onConfirm={confirm}
        />
      )}
      {step === 2 && (
        <Step2
          defaultUid={defaultUid}
          nftauthT={nftauthT}
          onConfirm={onUidConfirm}
        />
      )}
    </Modal>
  );
};
